export const formatCPF = (cpf: string): string => {
  if (!cpf) return "";

  const cleaned = cpf.replace(/\D/g, "");

  return cleaned
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};
